import { getModule, Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import { itiPermissionService, store } from '@/iti-core-vue';
import { CnaeCode } from '@/shared/dtos/cnae-code';
import { itiTokenService } from '@/iti-core-vue/services/iti-token-service';
import { ItiString, itiHttpService } from '@/iti-core-vue';
import { API } from '@/shared/api';



@Module({
    namespaced: true,
    name: 'CnaeCodeModule',
    store,
    dynamic: true,
})

class CnaeCodeModule extends VuexModule implements BaseModule {
    public cnaeCodes: CnaeCode[] = [];

    @Mutation
    public resetState(): void {
        this.cnaeCodes = [];
    }

    @Action
    public async getCnaeCodes() {
        if (!itiTokenService.hasToken()) { return; }
        const res = await itiHttpService.get(API.cnaeCode);
        this.context.commit('updateCnaeCodes', res);
    }

    @Mutation
    public updateCnaeCodes(items: CnaeCode[]) {
        this.cnaeCodes = items;
    }

    @Action
    public async insertarCnaeCode(item: CnaeCode) {
        if (!itiTokenService.hasToken()) { return; }
        const res = await itiHttpService.post(API.cnaeCode, item, false);
        this.context.dispatch('getCnaeCodes');
    }

    @Action
    public async modificarCnaeCode(item: CnaeCode) {
        if (!itiTokenService.hasToken()) { return; }
        try {
            const res = await itiHttpService.put(API.cnaeCode, item, false);
        } catch {
            // ...
        } 
        this.context.dispatch('getCnaeCodes');
    }

    @Action
    public async eliminarCnaeCode(id: number) {
        if (!itiTokenService.hasToken()) { return; }
        const apiDeleteCnaeCode = ItiString.Format(API.cnaeCodeDetail, id);
        const res = await itiHttpService.delete(apiDeleteCnaeCode, id, false);
        this.context.dispatch('getCnaeCodes');
    }
}

export default getModule(CnaeCodeModule);